import React from 'react'
import { Analytics } from '../lib/Analytics'

const AnalyticsContext = React.createContext<Analytics | null>(null)
AnalyticsContext.displayName = 'Analytics'

export default AnalyticsContext
